import {renderToReactElement} from '@tiptap/static-renderer';
import {parseProsemirrorState} from '../../../../common/utils/rtf-utils';
import StarterKit from '@tiptap/starter-kit';
import {Color, TextStyle} from '@tiptap/extension-text-style';
import styles from './TiptapRender.module.scss';

export interface TiptapRenderProps {
  content: string;
}

const extensions = [StarterKit, Color, TextStyle];

export default function TiptapRender({content}: TiptapRenderProps) {
  const render_content = parseProsemirrorState(content);
  if (!render_content) return <></>;

  const rtf = renderToReactElement({
    extensions,
    options: {
      unhandledNode: ({node}) => (g_is_dev ? `[unknown node ${node.type.name}]` : ''),
      unhandledMark: ({mark}) => (g_is_dev ? `[unknown node ${mark.type.name}]` : ''),
    },
    content: render_content,
  });

  return <div className={`${styles.rtf_render}`}>{rtf}</div>;
}
